import api from "../config/api";

export const authApi = {
  sendOtp: (mobile) => api.post("/auth/send-otp", { mobile }),

  verifyOtp: ({ mobile, otp, name }) =>
    api.post("/auth/verify-otp", { mobile, otp, name }),

  refresh: (refreshToken) => api.post("/auth/refresh", { refreshToken }),

  logout: () => api.post("/auth/logout"),

  getMe: () => api.get("/auth/me"),
};
